module.exports = __webpack_public_path__ + "img/slide01.125f3142.jpg";